var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgScrollTop = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 24 24"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  stroke: "#3C97AA",
  strokeWidth: 2,
  d: "M1 1h22v22H1z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#3C97AA",
  fillRule: "evenodd",
  d: "M19 14.506 17.607 16 12 9.987 6.393 16 5 14.506 12 7l7 7.506Z",
  clipRule: "evenodd"
})));
export { SvgScrollTop as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KICA8cmVjdCB4PSIxIiB5PSIxIiB3aWR0aD0iMjIiIGhlaWdodD0iMjIiIHN0cm9rZT0iIzNDOTdBQSIgc3Ryb2tlLXdpZHRoPSIyIiAvPgogIDxwYXRoIGZpbGwtcnVsZT0iZXZlbm9kZCIgY2xpcC1ydWxlPSJldmVub2RkIgogICAgZD0iTTE5IDE0LjUwNjNMMTcuNjA3MSAxNkwxMiA5Ljk4NzMxTDYuMzkyOSAxNkw1IDE0LjUwNjNMMTIgN0wxOSAxNC41MDYzWiIgZmlsbD0iIzNDOTdBQSIgLz4KPC9zdmc+";